import React from 'react';
import PropTypes from 'prop-types';
import CurrencyDropdown from '../Controls/CurrencyDropdown';
import Button from '../../Components/Controls/Button';
import {i18n, i18nString} from '../../Utility/Format';
import Icon from '../../Components/Helper/Icon';
import {unionBy, remove} from 'lodash';
import classnames from 'classnames';

const CurrencyPairOptions = (props) => {
    const currencyPairs = props.currencyPairs;
    const showRemoveButton = props.showRemoveButton || false;
    const locale = props.locale;
    const currencies = props.currencies || [];
    const baseCcys = currencies.filter(ccy => ccy.status === "BASE");
    // COUNTER currencies are the sum of BASE and COUNTER without duplicates
    const counterCcys = unionBy(baseCcys, currencies.filter(ccy => ccy.status === "COUNTER"), 'isoString');
    // we need to remove the currency from counters that was selected in BASE
    const getCountersWithoutBase = baseCcy => {
        remove(counterCcys, function (ccy) {
            return ccy.isoString === baseCcy.isoString
        });
        return counterCcys;
    };

    const classNames = classnames('currency-pairs', {
        'currency-pairs--showRemoveButton': showRemoveButton
    });

    return (
        <div className={classNames}>
            {
                currencyPairs.map((currencyPair, index) => {
                    return (
                        <div key={`currency-pairs__pair${index}`} className="currency-pairs__pair">
                            <div className="currency-pairs__pair__selector">
                                <CurrencyDropdown onChange={(newValue) => {
                                        props.onChangeCurrencyPair(index, 'base', newValue)
                                    }} data={baseCcys} value={currencyPair.base}
                                    aria-label={i18nString('dbm.currency.base', locale) }
                                />
                                <CurrencyDropdown onChange={(newValue) => {
                                        props.onChangeCurrencyPair(index, 'counter', newValue)
                                    }} data={getCountersWithoutBase(currencyPair.base)}
                                    value={currencyPair.counter}
                                    aria-label={i18nString('dbm.currency.counter', locale)}
                                />
                            </div>
                            {showRemoveButton ?
                                <Button isSquare={true} className="currency-pairs__pair__remove-button" aria-label="Remove button currency pair" onClick={() => {
                                    props.onRemoveCurrencyPair(index)
                                }}>
                                    <Icon name="close" isCollapsed={true} isSmall={true}/>
                                </Button> : null}
                            <div className="u-clearer"></div>
                        </div>
                    )
                })
            }
        </div>
    )
};

CurrencyPairOptions.propTypes = {
    currencyPairs: PropTypes.arrayOf(
        PropTypes.shape({
            isoString: PropTypes.string,
            status: PropTypes.string,
            label: PropTypes.string,
            country: PropTypes.string
        })
    ).isRequired,
    onChangeCurrencyPair: PropTypes.func.isRequired,
    showRemoveButton: PropTypes.bool,
    onRemoveCurrencyPair: PropTypes.func,
    currencies: PropTypes.array,
    locale: PropTypes.string.isRequired
};

export default CurrencyPairOptions;